import {
  Box,
  Button,
  Flex,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/core";
import React from "react";

function EditCard({ title, children, id }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <Box
      id={id}
      my="5"
      padding="1.5em"
      backgroundColor="#eeeeee"
      rounded="0.25em"
    >
      <Flex justify="space-between" align="center">
        <Text fontSize="lg">{title}</Text>
        <Button variant="ghost" onClick={onOpen} color="#41bb93">
          <Icon name="edit" />
        </Button>
      </Flex>
      {children}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{title}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>{children}</ModalBody>

          <ModalFooter>
            <Button variantColor="blue" mr={3} onClick={onClose}>
              Close
            </Button>
            <Button variant="ghost">Secondary Action</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
}

export default EditCard;
